import * as React from 'react'
import { connect } from 'react-redux'
import { spacerAlignItems, Spacer, spacerSpacing } from '@amzn/dvui/dist/Spacer'
import { PlaybackMessaging } from '../../components/playbackMessaging/playbackMessaging'
import { Refund } from '../../components/refund/refund'
import { TextBlockNotification } from '../../components/notificationAction/notificationAction'
import { Trailer } from '../../components/playback/trailer'
import { Watchlist } from '../../components/watchlist/watchlist'
import { DisneyAction } from '../../components/disneyAction/disneyAction'
import { RedeemAndPromoLink } from '../../components/redeemAndPromoLink/redeemAndPromoLink'
import { SecondaryOfferMessage } from '../../components/secondaryOfferMesssage/secondaryOfferMessage'
import { Acquisition } from '../../components/acquisition/acquisition'
import { AtfMorePurchaseOptions } from '../../components/morePurchaseOptions/atfMorePurchaseOptions'
import { MultiplePlayback } from '../../components/playback/multiplePlayback'
import { TvodButtonScope } from '../../components/acquisition/tvodButton'
import { AgeVerification } from '../../components/ageVerification/ageVerification'
import { TransactionOverlay } from '../../components/actionBox/disableOverlay'
import { IDetailPageState } from '../../reducers'
import * as utilityClasses from '../../components/utilityClasses.module.scss'
import {
  playbackMessagingComponentSelector,
  notificationActionsTextBlockMessagesSelector,
  trailerComponentSelector,
  purchaseComponentSelector,
  disneyComponentSelector,
  mwtwComponentSelector,
  secondaryOfferMessageComponentSelector,
  ageVerificationSelector,
  multiplePlaybackComponentSelector,
  downloadComponentSelector
} from '../../selectors/component/actionBoxComponentSelectors'
import { purchaseSelector } from '../../selectors/purchase'
import { isDeeplinkableActionReadySelector } from '../../selectors/pageContext'
import * as st from '../../components/actionBox/actionBox.module.scss'
import * as cn from 'classnames'
import { AdjustHeightForContent } from '../../utils/AdjustHeightForContent'
import { PurchaseFailedModal } from '../../components/actionBox/purchaseFailedModal'
import { DownloadStatus } from '@shared/SPA/UWPNotifier'
import { DownloadButtonWithLabel } from '@shared/SPA/downloadButton/DownloadButton'
import { DownloadAction } from '@shared/SPA/downloadButton/DownloadAction'
import { simpleSelectors } from '../../selectors/basicState'
import { GiftCardModal } from '../../components/giftCard/giftCardModal'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'
import { processDeeplinkFor } from '@shared/deeplink'
import { isMovieSelector } from '../../selectors/detailFragment'
import { DetailPageActionTypes } from '../../actions'
import { isTreatment } from '../../utils/utils'

type ActionBoxComponentProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps

export interface ActionBoxComponentState {
  giftCardModalIsVisible: boolean
}

export class ActionBoxComponent extends React.Component<ActionBoxComponentProps, ActionBoxComponentState> {

  constructor(props: ActionBoxComponentProps) {
    super(props)
    this.state = { giftCardModalIsVisible: false }
  }

  componentDidMount() {
    this.props.deeplinkingReady()
  }

  toggleGiftCardModal = () => {
    this.setState({ giftCardModalIsVisible: !this.state.giftCardModalIsVisible })
  }

  render() {
    const {
      playbackMessaging,
      notificationBox,
      playbackActions,
      downloadAction,
      trailerAction,
      purchaseAction,
      disneyAction,
      moreWaysToWatch,
      secondaryOfferMessage,
      ageVerification,
      purchaseDetails,
      pageTitleId,
      isRefunding,
      isDeeplinkableActionReady,
      requestContext,
      downloadLaunchType,
      isMovie,
      atfTreatment
    } = this.props

    const isPurchasingMfa = Boolean(purchaseDetails)

    const transactionText = (isPurchasingMfa &&
        purchaseDetails!.details &&
        purchaseDetails!.details!.offer.purchaseData.text) || ''
    const isProcessingTransaction = isPurchasingMfa || isRefunding

    const downloadHandle =
      downloadLaunchType === 'NONE' || downloadLaunchType === 'EMBEDDED'
        ? undefined
        : (e: React.MouseEvent) => {
            e.preventDefault()
            processDeeplinkFor[downloadLaunchType]({
              url: downloadAction.downloadURL,
              fallbackUrl: downloadAction.fallbackURL,
            })
          }

    const deeplinkingProps = {
      ...downloadAction,
      status: DownloadStatus.IDLE,
      forceDoubleHeight: true,
      onClick: downloadHandle,
    }
    const downloadInfo = {
      ...downloadAction,
      isMovie,
    }

    // For T1/T2/T3 we need to only show messages with Logos in the Action box, the rest will be rendered right above the HQP
    const playbackMessagingProps = isTreatment(atfTreatment, 'T1', 'T2', 'T3') ?
      { messagesWithLogo: playbackMessaging.messagesWithLogo } : playbackMessaging

    const playbackMessagingCNs = [{[st.actionBoxPlaybackMessages]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')}]

    return (
      <div className={cn(st.actionBox, st.actionBoxRedesign)}>
        <div
          className={cn(
            {[st.isProcessingTransaction]: isProcessingTransaction},
            st.wrapper
          )}>
          <AdjustHeightForContent className={'dv-node-dp-action-box'}>
            <PlaybackMessaging {...playbackMessagingProps} atfTreatment={atfTreatment} removeMessagesWithLogo={false} classNames={playbackMessagingCNs}/>
            {!isTreatment(atfTreatment, 'T1', 'T2', 'T3') && <AgeVerification {...ageVerification}/> }
            <Refund titleId={pageTitleId} atfTreatment={atfTreatment}/>
            <Spacer alignItems={spacerAlignItems.top} className={cn({[st.actionBoxButtons]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
              <TextBlockNotification {...notificationBox} atfTreatment={atfTreatment}/>
              {isDeeplinkableActionReady && playbackActions && <MultiplePlayback {...playbackActions} atfTreatment={atfTreatment}/>}
              <Spacer
                alignItems={spacerAlignItems.top}
                  className={utilityClasses.fullWidthPhablet}>
                {!isTreatment(atfTreatment, 'T1', 'T2', 'T3') && isDeeplinkableActionReady && trailerAction && <Trailer {...trailerAction}/>}
                <Acquisition
                  {...purchaseAction}
                  tvodButtonScope={TvodButtonScope.ACTION_BOX}
                  forceDoubleHeight={true}
                  atfTreatment={atfTreatment}
                />
                {moreWaysToWatch && (
                  <AtfMorePurchaseOptions {...moreWaysToWatch} toggleGiftCardModal={this.toggleGiftCardModal} atfTreatment={atfTreatment}/>
                )}
                {!isTreatment(atfTreatment, 'T1', 'T2', 'T3') && <Watchlist/>}
                <DisneyAction {...disneyAction} atfTreatment={atfTreatment}/>
                {isDeeplinkableActionReady && downloadAction &&
                  (global.__NATIVEAPP__ ? (
                    <DownloadAction downloadInfo={downloadInfo} isAtf atfTreatment={atfTreatment} />
                  ) : (
                    <DownloadButtonWithLabel {...deeplinkingProps} atfTreatment={atfTreatment}/>
                  ))}
              </Spacer>
            </Spacer>
            <div className={spacerSpacing.s}>
              <RedeemAndPromoLink placement={'ActionBox'} toggleGiftCardModal={this.toggleGiftCardModal} atfTreatment={atfTreatment}/>
              <SecondaryOfferMessage {...secondaryOfferMessage} />
            </div>
          </AdjustHeightForContent>
        </div>
        {isProcessingTransaction && (
          <TransactionOverlay text={transactionText}/>
        )}
        <PurchaseFailedModal/>
        <GiftCardModal isOpen={this.state.giftCardModalIsVisible}
                       onClose={this.toggleGiftCardModal}
                       requestContext={requestContext.rawContext}/>
      </div>
    )
  }
}

const mapStateToProps = (state: IDetailPageState) => ({
  pageTitleId: state.pageTitleId,
  playbackMessaging: playbackMessagingComponentSelector(state),
  notificationBox: notificationActionsTextBlockMessagesSelector(state),
  playbackActions: multiplePlaybackComponentSelector(state),
  downloadAction: downloadComponentSelector(state),
  trailerAction: trailerComponentSelector(state),
  purchaseAction: purchaseComponentSelector(state),
  disneyAction: disneyComponentSelector(state),
  moreWaysToWatch: mwtwComponentSelector(state),
  secondaryOfferMessage: secondaryOfferMessageComponentSelector(state),
  ageVerification: ageVerificationSelector(state),
  purchaseDetails: purchaseSelector(state),
  isRefunding: Boolean(state.refund.refunding),
  isDeeplinkableActionReady: isDeeplinkableActionReadySelector(state),
  requestContext: sanitizedRequestContextSelector(state),
  downloadLaunchType: state.pageContext.downloadLaunchType,
  isMovie: isMovieSelector(state),
  atfTreatment: simpleSelectors.atfTreatment(state)
})

const mapDispatchToProps = {
  deeplinkingReady: () => ({ type: DetailPageActionTypes.DeeplinkingReady })
}

export const ActionBox = connect(mapStateToProps, mapDispatchToProps)(ActionBoxComponent)
